import axios from 'axios'
import authHeader from './auth-header'

const base = `${process.env.VUE_APP_API_URL}crm-rematricula`
const request = (method, path, data) =>
  axios({
    method,
    url: `${base}/${path}`,
    headers: authHeader(),
    timeout: 35000,
    ...(method === 'get' ? { params: data } : { data })
  }).then((r) => r.data)

// Share requests for cards from the same unit; keep cold DW reads off the portfolio path.
const warningRequests = new Map()
const warningQueue = []
let warningWorkers = 0
const drainWarnings = () => {
  while (warningWorkers < 2 && warningQueue.length) {
    const job = warningQueue.shift()
    warningWorkers++
    job().finally(() => { warningWorkers--; drainWarnings() })
  }
}
const unitWarnings = (unitId, year) => {
  const key = `${unitId}:${year}`
  if (!warningRequests.has(key)) {
    const promise = new Promise((resolve) => {
      warningQueue.push(async () => {
        try {
          for (let attempt = 0; attempt < 6; attempt++) {
            const result = await request('get', 'warnings', { unit_id: unitId, source_year: year })
            if (result.state !== 'pending') { resolve(result); return }
            if (attempt < 5) await new Promise(done => setTimeout(done, 2000))
          }
          resolve({ state: 'unavailable', students: {} })
        } catch (_) { resolve({ state: 'unavailable', students: {} }) }
      })
      drainWarnings()
    }).finally(() => warningRequests.delete(key))
    warningRequests.set(key, promise)
  }
  return warningRequests.get(key)
}

export default {
  unitWarnings,
  metadata: () => request('get', 'metadata'),
  series: (params) => request('get', 'series', params),
  operators: (params) => request('get', 'operators', params),
  heatmap: (params) => request('get', 'heatmap', params),
  students: (params) => request('get', 'students', params),
  portfolio: (params) => request('get', 'portfolio', {
    ...params,
    ...(typeof params.only_overdue === 'boolean' ? { only_overdue: Number(params.only_overdue) } : {})
  }),
  renewalLink: (id) => request('get', `negotiations/${id}/renewal-link`),
  exportPortfolio: (params) => axios({
    method: 'get', url: `${base}/portfolio/export`, headers: authHeader(), responseType: 'blob', timeout: 120000,
    params: { ...params, ...(typeof params.only_overdue === 'boolean' ? { only_overdue: Number(params.only_overdue) } : {}) }
  }).then(r => r.data),
  detail: (id) => request('get', `negotiations/${id}`),
  create: (data) => request('post', 'negotiations', data),
  update: (id, data) => request('put', `negotiations/${id}`, data),
  assign: (data) => request('post', 'assign', data),
  contact: (id, data) => request('post', `negotiations/${id}/contacts`, data),
  tasks: (params) => request('get', 'tasks', params),
  saveTask: (id, data, taskId) =>
    request(taskId ? 'put' : 'post', `negotiations/${id}/tasks${taskId ? `/${taskId}` : ''}`, data),
  closeTask: (id, data) => request('post', `tasks/${id}/close`, data),
  saveOption: (kind, data, id) => request(id ? 'put' : 'post', `options/${kind}${id ? `/${id}` : ''}`, data),
  insights: (params) => request('get', 'insights', params),
  reconciliations: (params) => request('get', 'reconciliations', params),
  candidates: (id, params) => request('get', `reconciliations/${id}/candidates`, params),
  associate: (id, data) => request('post', `reconciliations/${id}`, data)
}
